import { AlertTriangle } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { FulfillmentRiskPage } from './pages/FulfillmentRiskPage'

/**
 * Fulfillment Risk — M9 DataView with Commercial | Samples sub-nav.
 *
 * Badge polls /api/fulfillment/risk every 180s, extracts
 * `commercial.summary.CRITICAL` for the danger count. Replaces
 * reports.siliconesplus.com/fulfillment.
 */
export default defineModule({
  id: 'fulfillment-risk',
  name: 'Fulfillment Risk',
  shortName: 'Risk',
  icon: AlertTriangle,
  navSection: 'sales',
  navOrder: 30,
  urlNamespace: '/fulfillment',
  routes: [
    { path: '/', element: FulfillmentRiskPage, label: 'Fulfillment Risk' },
  ],
  permissions: ['admin', 'sales', 'operations', 'operations_logistics', 'purchasing'],
  densityDefault: 'comfortable',
  filterRailDefault: 'collapsed',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g f',

  commandPaletteEntries: [
    {
      label: 'Go to Fulfillment Risk',
      keywords: ['fulfillment', 'risk', 'pick', 'shortage', 'stock'],
      path: '/',
      group: 'modules',
      shortcut: 'g f',
    },
  ],

  deepLinkHandlers: [
    {
      entity: 'customer',
      label: 'View fulfillment risk for this customer',
      buildPath: (customerId) => `/?customer=${customerId}`,
    },
    {
      entity: 'product',
      label: 'View fulfillment risk for this product',
      buildPath: (productId) => `/?product=${productId}`,
    },
    {
      entity: 'so',
      label: 'View risk on this sale order',
      buildPath: (soId) => `/?so=${soId}`,
    },
  ],
})
